import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isBetween from 'dayjs/plugin/isBetween';
import { GppGood as GppGoodIcon, GppBad as GppBadIcon } from '@mui/icons-material';
import { CommonLabel } from './Common';

dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);

export const PositionStatusLabel = (position, iconLabel) => {
  let color;
  let backgroundColor;
  let text;
  let icon;

  if (
    (position.end_date === 'Invalid Date' || position.end_date === null || position.end_date === undefined) &&
    dayjs(position.end_date).isAfter(dayjs())
  ) {
    color = '#007867';
    backgroundColor = '#22c55e29';
    text = 'In carica';
    icon = <GppGoodIcon sx={{ color: '#54d62c' }} />;
  } else if (dayjs().isBetween(dayjs(position.start_date), dayjs(position.end_date), 'day', '[]')) {
    color = '#007867';
    backgroundColor = '#22c55e29';
    text = 'In carica';
    icon = <GppGoodIcon sx={{ color: '#54d62c' }} />;
  } else if (dayjs(position.start_date).isBefore(dayjs(), 'day')) {
    color = '#b71d18';
    backgroundColor = '#ff563029';
    text = 'Non in carica';
    icon = <GppBadIcon sx={{ color: 'red' }} />;
  } else if (dayjs(position.start_date).isAfter(dayjs(), 'day')) {
    color = '#b71d18';
    backgroundColor = '#ff563029';
    text = 'Non in carica';
    icon = <GppBadIcon sx={{ color: 'red' }} />;
  }

  if (iconLabel === 'label') {
    return <CommonLabel textColor={color} bgColor={backgroundColor} text={text} />;
  }
  if (iconLabel === 'icon') {
    return icon;
  }
  return null;
};
